import React from 'react';
import PureComponent from 'components/PureComponent';

class Column extends PureComponent {

	render() {
		return (
			<div className={`Content__column ${this.props.className}`} {...this.props}>
				{this.props.children}
			</div>
		);
	}

}

export default Column;



// WEBPACK FOOTER //
// ./src/components/Content/Column.js